/*
 * @Author: your name
 * @Date: 2021-08-22 16:24:17
 * @LastEditTime: 2023-01-12 19:30:46
 * @LastEditors: bobo 350910378@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \my-app\src\global\FormulaCalc.js
 */
// import chevrotain from 'chevrotain'

import {BsyUtils} from '../utils/Utils'
import { BsyFormulaCalcParser} from './FormulaCalcParser'



export class BsyFormulaCalc {
    constructor() {
        this.tokenMap = this._getTokenMap();
        this.allTokens = this._getAllTokens();
        this.lexer = this._getLexer();
        this.parser = this._getParser();
        this.interpreter = this._getInterpreter()
    }

    _getTokenMap = () => {
        var t = window.chevrotain.createToken,
            e = window.chevrotain.Lexer,
            i = t({
                name: "Unary",
                pattern: e.NA
            }),
            a = t({
                name: "Addition",
                pattern: e.NA
            }),
            s = t({
                name: "Multiplication",
                pattern: e.NA
            }),
            n = t({
                name: "Equal",
                pattern: e.NA
            }),
            o = t({
                name: "Compare",
                pattern: e.NA
            });
        return {
            WhiteSpace: t({
                name: "WhiteSpace",
                pattern: /\s+/,
                group: e.SKIPPED
            }),
            String: t({
                name: "String",
                pattern: /("(\\\\|\\"|[^"])*"|'(\\\\|\\'|[^'])*')/
            }),
            Number: t({
                name: "Number",
                pattern: /[0-9]+(\.[0-9]+)?(e[+-]?[0-9]+)?/
            }),
            Boolean: t({
                name: "Boolean",
                pattern: /(true|false)/
            }),
            Empty: t({
                name: "Empty",
                pattern: /(null|undefined)/
            }),
            NaN: t({
                name: "NaN",
                pattern: /NaN/
            }),
            Comma: t({
                name: "Comma",
                pattern: /,/
            }),
            Func: t({
                name: "Func",
                        pattern: /[A-Z0-9_]+/
            }),
            LParen: t({
                name: "LParen",
                pattern: /\(/
            }),
            RParen: t({
                name: "RParen",
                pattern: /\)/
            }),
            LSquare: t({
                name: "LSquare",
                pattern: /\[/
            }),
            RSquare: t({
                name: "RSquare",
                pattern: /]/
            }),
            Plus: t({
                name: "Plus",
                pattern: /\+(?!\+)/,
                categories: [i, a]
            }),
            Minus: t({
                name: "Minus",
                pattern: /-(?!-)/,
                categories: [i, a]
            }),
            Unary: i,
            Addition: a,
            Multi: t({
                name: "Multi",
                pattern: /\*/,
                categories: [s]
            }),
            Div: t({
                name: "Div",
                pattern: /\//,
                categories: [s]
            }),
            Multiplication: s,
            LessOrEqual: t({
                name: "LessOrEqual",
                pattern: /<=/,
                categories: [o]
            }),
            GreaterOrEqual: t({
                name: "GreaterOrEqual",
                pattern: />=/,
                categories: [o]
            }),
            Less: t({
                name: "Less",
                pattern: /</,
                categories: [o]
            }),
            Greater: t({
                name: "Greater",
                pattern: />/,
                categories: [o]
            }),
            Compare: o,
            EqualStrict: t({
                name: "EqualStrict",
                pattern: /===/,
                categories: [n]
            }),
            NotEqualStrict: t({
                name: "NotEqualStrict",
                pattern: /!==/,
                categories: [n]
            }),
            EqualLoose: t({
                name: "EqualLoose",
                pattern: /==/,
                categories: [n]
            }),
            NotEqualLoose: t({
                name: "NotEqualLoose",
                pattern: /!=/,
                categories: [n]
            }),
            Equal: n,
            LogicNot: t({
                name: "LogicNot",
                pattern: /!/,
                categories: [i]
            }),
            LogicAnd: t({
                name: "LogicAnd",
                pattern: /&&/
            }),
            LogicOr: t({
                name: "LogicOr",
                pattern: /\|\|/
            }),
            BitAnd: t({
                name: "BitAnd",
                pattern: /&/
            }),
            BitOr: t({
                name: "BitOr",
                pattern: /\|/
            })
        }
    }
    _getAllTokens = () => {
        var t = this.tokenMap;
        return [t.WhiteSpace, t.String, t.Number, t.NaN, t.Boolean, t.Empty, t.Func, t.LParen, t.RParen, t.LSquare, t.RSquare, t.Plus, t.Minus, t.Addition, t.Unary, t.Multi, t.Div, t.Multiplication, t.LessOrEqual, t.GreaterOrEqual, t.Less, t.Greater, t.Compare, t.EqualStrict, t.NotEqualStrict, t.EqualLoose, t.NotEqualLoose, t.Equal, t.LogicNot, t.LogicAnd, t.LogicOr, t.BitAnd, t.BitOr, t.Comma]
    }
    _getLexer = () => {
        return new window.chevrotain.Lexer(this.allTokens, {
            ensureOptimizations: !0
        })
    }
    _getParser = () => {
        function t() {
            i.call(this, e.allTokens);
            var t = this,
                a = e.tokenMap;
            t.RULE("expr", function () {
                t.SUBRULE(t.commaExpression)
            })
            t.RULE("commaExpression", function () {
                t.SUBRULE(t.orExpression)
                t.MANY(function () {
                    t.CONSUME(a.Comma)
                    t.SUBRULE2(t.orExpression)
                })
            })
            t.RULE("orExpression", function () {
                t.SUBRULE(t.andExpression)
                t.MANY(function () {
                    t.CONSUME(a.LogicOr)
                    t.SUBRULE2(t.andExpression)
                })
            })
            t.RULE("andExpression", function () {
                t.SUBRULE(t.bitOrExpression)
                t.MANY(function () {
                    t.CONSUME(a.LogicAnd)
                    t.SUBRULE2(t.bitOrExpression)
                })
            })
            t.RULE("bitOrExpression", function () {
                t.SUBRULE(t.bitAndExpression)
                t.MANY(function () {
                    t.CONSUME(a.BitOr)
                    t.SUBRULE2(t.bitAndExpression)
                })
            })
            t.RULE("bitAndExpression", function () {
                t.SUBRULE(t.equalExpression)
                t.MANY(function () {
                    t.CONSUME(a.BitAnd)
                    t.SUBRULE2(t.equalExpression)
                })
            })
            t.RULE("equalExpression", function () {
                t.SUBRULE(t.compareExpression)
                t.MANY(function () {
                    t.CONSUME(a.Equal)
                    t.SUBRULE2(t.compareExpression)
                })
            })
            t.RULE("compareExpression", function () {
                t.SUBRULE(t.additionExpression)
                t.MANY(function () {
                    t.CONSUME(a.Compare)
                    t.SUBRULE2(t.additionExpression)
                })
            })
            t.RULE("additionExpression", function () {
                t.SUBRULE(t.multiplicationExpression)
                t.MANY(function () {
                    t.CONSUME(a.Addition)
                    t.SUBRULE2(t.multiplicationExpression)
                })
            })
            t.RULE("multiplicationExpression", function () {
                t.SUBRULE(t.unaryExpression)
                t.MANY(function () {
                    t.CONSUME(a.Multiplication)
                    t.SUBRULE2(t.unaryExpression)
                })
            })
            t.RULE("unaryExpression", function () {
                t.MANY(function () {
                    t.CONSUME(a.Unary)
                })
                t.SUBRULE(t.atomicExpression)
            })
            t.RULE("atomicExpression", function () {
                t.OR(t.c1 || (t.c1 = [{
                    ALT: () => {
                        t.SUBRULE(t.array)
                    }
                }, {
                    ALT: () => {
                        t.SUBRULE(t.func)
                    }
                }, {
                    ALT: () => {
                        t.SUBRULE(t.group)
                    }
                }, {
                    ALT: () => {
                        t.SUBRULE(t.base)
                    }
                }]))
                t.MANY(function () {
                    t.CONSUME(a.LSquare)
                    t.SUBRULE(t.expr)
                    t.CONSUME(a.RSquare)
                })
            })
            t.RULE("array", function () {
                t.CONSUME(a.LSquare)
                t.MANY_SEP({
                    SEP: a.Comma,
                    DEF: () => {
                        t.SUBRULE(t.orExpression)
                    }
                })
                t.CONSUME(a.RSquare)
            })
            t.RULE("func", function () {
                t.CONSUME(a.Func)
                t.CONSUME(a.LParen)
                t.OPTION(function () {
                    t.SUBRULE(t.orExpression)
                    t.MANY(function () {
                        t.CONSUME(a.Comma)
                        t.SUBRULE2(t.orExpression)
                    })
                    t.OPTION2(function () {
                        t.CONSUME2(a.Comma)
                    })
                })
                t.CONSUME(a.RParen)
            })
            t.RULE("group", function () {
                t.CONSUME(a.LParen)
                t.AT_LEAST_ONE_SEP({
                    SEP: a.Comma,
                    DEF: () => {
                        t.SUBRULE(t.expr)
                    }
                })
                t.CONSUME(a.RParen)
            })
            t.RULE("base", function () {
                t.OR(t.c2 || (t.c2 = [{
                    ALT: () => {
                        t.CONSUME(a.String)
                    }
                }, {
                    ALT: () => {
                        t.CONSUME(a.Number)
                    }
                }, {
                    ALT: () => {
                        t.CONSUME(a.Boolean)
                    }
                }, {
                    ALT: () => {
                        t.CONSUME(a.Empty)
                    }
                }, {
                    ALT: () => {
                        t.CONSUME(a.NaN)
                    }
                }]))
            })
            this.performSelfAnalysis()
        }
        var e = this,
        i = window.chevrotain.Parser; //先暂时使用老的
            // i = window.chevrotain.CstParser;
         t.prototype = Object.create(i.prototype);
        t.prototype.constructor = t;
        return new t([])
    }
    _getInterpreter = () => {
        let that = this;
        function e() {
            i.apply(this, arguments);
            this.validateVisitor()
        }
        var i = this.parser.getBaseCstVisitorConstructor();
        (e.prototype = Object.create(i.prototype)).constructor = e;
        var a = window.chevrotain.tokenMatcher,
            s = this.tokenMap;
        //  Object.assign(e.prototype, {
            e.prototype.expr= (t) => {
                return that.interpreter.visit(t.commaExpression)
            }
            e.prototype.commaExpression = (t) => {
                var e = t.orExpression.slice(-1)[0];
                return that.interpreter.visit(e)
            }
            e.prototype.orExpression = (t) => {
                var e = null
                BsyUtils.forEach(t.andExpression, function (t, a) {
                    e = 0 === t ? that.interpreter.visit(a) : e || that.interpreter.visit(a)
                })
                return e
            }
            e.prototype.andExpression= (t) => {
                var e = null
                 BsyUtils.forEach(t.bitOrExpression, function (t, a) {
                        e = 0 === t ? that.interpreter.visit(a) : e && that.interpreter.visit(a)
                    })
                return e
            }
            e.prototype.bitOrExpression= (t) => {
                var e = null
                 BsyUtils.forEach(t.bitAndExpression, function (t, a) {
                        0 === t ? e = that.interpreter.visit(a) : e |= that.interpreter.visit(a)
                    })
                return e
            }
            e.prototype.bitAndExpression= (t) => {
                var e = null
                BsyUtils.forEach(t.equalExpression, function (t, a) {
                        0 === t ? e = that.interpreter.visit(a) : e &= that.interpreter.visit(a)
                    })
                return e
            }
            e.prototype.equalExpression= (t) => {
                var e = that.interpreter.visit(t.compareExpression)

                 BsyUtils.forEach(t.Equal, function (n, o) {
                        var r = that.interpreter.visit(t.compareExpression[n + 1]);
                        e = a(o, s.EqualStrict) ? e === r : a(o, s.NotEqualStrict) ? e !== r : a(o, s.EqualLoose) ? e == r : e != r
                    })
                return e
            }
            e.prototype.compareExpression= (t) => {
                var e = that.interpreter.visit(t.additionExpression)
                 BsyUtils.forEach(t.Compare, function (n, o) {
                        var r = that.interpreter.visit(t.additionExpression[n + 1]);
                        e = a(o, s.LessOrEqual) ? e <= r : a(o, s.GreaterOrEqual) ? e >= r : a(o, s.Less) ? e < r : e > r
                    })
                return e
            }
            e.prototype.additionExpression= (t) => {
                var e = that.interpreter.visit(t.multiplicationExpression)
                 BsyUtils.forEach(t.Addition, function (n, o) {
                        var r = that.interpreter.visit(t.multiplicationExpression[n + 1]);
                        e = a(o, s.Plus) ? BsyFormulaCalcParser.evalExpression("+", e, r) : BsyFormulaCalcParser.evalExpression("-", e, r)
                    })
                return e
            }
            e.prototype.multiplicationExpression= (t) => {
                var e = that.interpreter.visit(t.unaryExpression)
                 BsyUtils.forEach(t.Multiplication, function (n, o) {
                        var r = that.interpreter.visit(t.unaryExpression[n + 1]);
                        e = a(o, s.Multi) ? BsyFormulaCalcParser.evalExpression("*", e, r) : BsyFormulaCalcParser.evalExpression("/", e, r)
                    })
                return e
            }
            e.prototype.unaryExpression= (t) => {
                var e = that.interpreter.visit(t.atomicExpression);
                if (!t.Unary)
                    return e;
                var i = t.Unary.slice().reverse();
                 BsyUtils.forEach(i, function (t, i) {
                        e = a(i, s.Minus) ? -e : a(i, s.Plus) ? +e : !e
                    })
                return e
            }
            e.prototype.atomicExpression= (t) => {
                var e = null
                t.base ? e = that.interpreter.visit(t.base) : t.group ? e = that.interpreter.visit(t.group) : t.array ? e = that.interpreter.visit(t.array) : t.func && (e = that.interpreter.visit(t.func))
                BsyUtils.forEach(t.expr, function (t, a) {
                    var s = that.interpreter.visit(a);
                    e = e[s]
                })
                return e
            }
            e.prototype.array= (t) => {
                var e = []
                 BsyUtils.forEach(t.orExpression, function (t, a) {
                        e.push(that.interpreter.visit(a))
                    })
                return e
            }
            e.prototype.func= (t) => {
                var i = t.Func[0].image,
                    a = [];
                 BsyUtils.forEach(t.orExpression, function (t, i) {
                        a.push(that.interpreter.visit(i))
                    })
                return BsyFormulaCalcParser.applyFunc(i, a)
            }
            e.prototype.group= (t) => {
                return that.interpreter.visit(t.expr)
            }
            e.prototype.base= (t) => {
                if (t.String) {
                    var e = t.String[0].image;
                    return e.substring(1, e.length - 1)
                }
                return t.Number ? Number(t.Number[0].image) : t.Boolean ? "true" === t.Boolean[0].image.toLowerCase() : t.Empty ? null : t.NaN ? NaN : void 0
            }
        // }
        // )
        return new e();
    }
    parse = (t) => {
        var e = this.lexer.tokenize(t);
        if (e.errors.length > 0) {

            console.log("Lexer Errors:", e.errors)
            return null;
        }

        this.parser.input = e.tokens;
        var i = this.parser.expr();

        if(this.parser.errors.length > 0) {
            console.log("Parser Errors:", this.parser.errors)
            return null;
        }

        return this.interpreter.visit(i)
    }
}